import helpscout_beacon from "helpscout_beacon"
import * as Ladda from "ladda"
import React from "react"
import FaIcon from "components/fa_icon"

const FeedbackIcon = ({title, get_feedback_data = () => {}}) => {
  const link_ref = React.useRef(null)
  const open_feedback_beacon = () => {
    const Beacon = helpscout_beacon(get_feedback_data())
    Beacon("open")
    if (window.beacon_is_ready) return
    const ladda = Ladda.create(link_ref.current)
    ladda.start()
    return Beacon("on", "ready", () => ladda.stop())
  }
  return (
    <a
      ref={link_ref}
      title={title}
      data-style="zoom-out"
      data-spinner-color="#676F77"
      onClick={open_feedback_beacon}>
      <FaIcon name={"fa-flag"}/>
    </a>
  )
}

export default FeedbackIcon
